/*@flow*/
import type { Element } from 'react';
import React from 'react';
import cx from 'classnames';

export default ({ isActive }: { isActive: boolean }): Element<'span'> => (
  <span className="section-toggle">
    <i
      className={cx('fa', {
        'fa-caret-right': !isActive,
        'fa-caret-down': isActive,
      })}
    />
  </span>
);
